// actions
const SHOW_CONTEXT_MENU = 'SHOW_CONTEXT_MENU'
const HIDE_CONTEXT_MENU = 'HIDE_CONTEXT_MENU'

// reducer
const initialState = {
  rowIndex: null,
  data: null,
  node: null,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_CONTEXT_MENU:
      const { rowIndex, data, node } = action
      return Object.assign({}, state, {
        rowIndex,
        data,
        node,
      })

    case HIDE_CONTEXT_MENU:
      return Object.assign({}, state, {
        rowIndex: null,
        data: null,
      })

    default:
      return state
  }
};

// action creators
export const showContextMenu = (rowIndex, data, node) => {
  return {
    type: SHOW_CONTEXT_MENU,
    rowIndex,
    data,
    node,
  }
}

export const hideContextMenu = () => {
  return {
    type: HIDE_CONTEXT_MENU,
  }
}
